setTimeout(() =>{
  let buttonAddtoCart = document.querySelectorAll('cart-live-region')
  buttonAddtoCart.forEach((e)=>{
    e.addEventListener('click', async ()=>{
     const res = await BSS_B2B.storage.productStorage.load();
                BSS_B2B.observer.productSubject.notifyObserver('LazyProduct', 'LoadedLazyProduct', res)
      
    })
  })
  }, 500)